import type { RentalOfferCardCopy } from '@voll-intelligence/intelligence-ui-kit';
import type { GenUiTranslate } from '../../shared/ui/i18n.js';

/** Os textos do miolo do card de carro do kit — a listagem e o contrato do
 *  checkout leem os mesmos. */
export function rentalVehicleCopy(t: GenUiTranslate): Omit<RentalOfferCardCopy, 'selectLabel'> {
  return {
    automaticLabel: t('rental.automatic'),
    automaticShortLabel: t('rental.automaticShort'),
    manualLabel: t('rental.manual'),
    airConditioningLabel: t('rental.airConditioning'),
    noAirConditioningLabel: t('rental.noAirConditioning'),
    pickupLabel: t('rental.pickup.label'),
    dropoffLabel: t('rental.dropoff.label'),
  };
}
